"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tools = exports.EmailComponents = exports.Components = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _formik = require("formik");

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _find = _interopRequireDefault(require("lodash/find"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _values = _interopRequireDefault(require("lodash/values"));

var _transform = _interopRequireDefault(require("lodash/transform"));

var _ThemeProvider = _interopRequireDefault(require("elevate-ui/ThemeProvider"));

var _noScroll = _interopRequireDefault(require("no-scroll"));

var _export = _interopRequireDefault(require("./utils/export"));

var _generateUuid = _interopRequireDefault(require("./utils/generate-uuid"));

var _constants = _interopRequireDefault(require("./utils/constants"));

var _applyDefaults = _interopRequireDefault(require("./utils/apply-defaults"));

var _cloneContent = _interopRequireDefault(require("./utils/clone-content"));

var _stringReplace = _interopRequireDefault(require("./utils/string-replace"));

var _RenderContent = _interopRequireDefault(require("./Internals/RenderContent"));

var _SidebarForm = _interopRequireDefault(require("./Internals/SidebarForm"));

var _ToolboxModal = _interopRequireDefault(require("./Internals/ToolboxModal"));

var _UnsavedChangesModal = _interopRequireDefault(require("./Internals/UnsavedChangesModal"));

var _ToolboxItem = _interopRequireDefault(require("./Components/Common/ToolboxItem"));

var _Button = _interopRequireDefault(require("./Components/Button"));

var _HorizontalRule = _interopRequireDefault(require("./Components/HorizontalRule"));

var _Image = _interopRequireDefault(require("./Components/Image"));

var _Row = _interopRequireDefault(require("./Components/Row"));

var _Script = _interopRequireDefault(require("./Components/Script"));

var _TwoCol = _interopRequireDefault(require("./Components/TwoCol"));

var _ThreeCol = _interopRequireDefault(require("./Components/ThreeCol"));

var _FourCol = _interopRequireDefault(require("./Components/FourCol"));

var _FiveCol = _interopRequireDefault(require("./Components/FiveCol"));

var _Text = _interopRequireDefault(require("./Components/Text"));

var _Row2 = _interopRequireDefault(require("./Components/Email/Row"));

var _Image2 = _interopRequireDefault(require("./Components/Email/Image"));

var _Wrapper = _interopRequireDefault(require("./Components/Email/Wrapper"));

var _HorizontalRule2 = _interopRequireDefault(require("./Components/Email/HorizontalRule"));

var _Button2 = _interopRequireDefault(require("./Components/Email/Button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InternalComponents = [_Button["default"], _Script["default"], _HorizontalRule["default"], _Image["default"], _Text["default"], _Row["default"], _TwoCol["default"], _ThreeCol["default"], _FourCol["default"], _FiveCol["default"]];

// a little function to help us with reordering the result
function reorderContent(components, startIndex, endIndex) {
  if (!(components && components.length)) {
    return components;
  }

  var result = (0, _toConsumableArray2["default"])(components);

  var _result$splice = result.splice(startIndex, 1),
      _result$splice2 = (0, _slicedToArray2["default"])(_result$splice, 1),
      removed = _result$splice2[0];

  result.splice(endIndex, 0, removed);
  return result;
}

function renderReact(options) {
  var allComponents = combineComponents(options.components || []);
  return /*#__PURE__*/_react["default"].createElement(_ThemeProvider["default"], {
    theme: {
      colors: {},
      overrides: {
        EuiScaffold: {
          root: {
            margin: "0 auto"
          }
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_RenderContent["default"], {
    content: Editor.setDefaultProps(options.content || [], allComponents),
    internals: {
      isEditor: false,
      // an indicator to not show CSS related to editing content
      components: allComponents,
      previewPlaceholders: options.previewPlaceholders || false,
      addChildToContent: function addChildToContent() {},
      deleteContent: function deleteContent() {},
      showSidebar: function showSidebar(e, id) {
        return;
      },
      editingContentFormAttrs: null,
      editingContentId: null
    }
  }));
}

function combineComponents() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Add default components, but allows props.components to overwrite default components
  var combined = components && components.length ? (0, _toConsumableArray2["default"])(components) : [];
  InternalComponents.forEach(function (component) {
    if (!(0, _find["default"])(components, {
      type: component.type
    })) {
      combined.push(component);
    }
  });
  return combined;
}

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Editor);
    _this = _super.call(this, _props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "props", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "keydownListener", function (e) {
      if (e.keyCode === 27) {
        // Escape key
        if (_this.state.editingContent) {
          _this.cancelEdit();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "exportHTML", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        content: _this.state.content,
        components: _this.state.components,
        inlineCss: false
      };
      return (0, _export["default"])(options);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "exportJSON", function () {
      return _this.state.content;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelEdit", function () {
      _this.setState({
        editingContent: null,
        toolboxModalId: null
      }, function () {
        return _this.handleUnsavedChanges();
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openToolboxModal", function (toolboxModalId) {
      _this.setState({
        toolboxModalId: toolboxModalId
      }, function () {
        return _noScroll["default"].on();
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteContent", function (contentId) {
      if (!contentId) {
        return;
      }

      var content = (0, _toConsumableArray2["default"])(_this.state.content);

      _this.recursiveDelete(contentId, content);

      _this.setState({
        content: content,
        editingContent: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDragEnd", function (_ref) {
      var source = _ref.source,
          destination = _ref.destination;

      if (!(destination && destination.droppableId)) {
        return;
      }

      var content = _this.findContentById(destination.droppableId);

      if (destination && content) {
        content.content = reorderContent(content.content, source.index, destination.index);

        _this.setState({
          content: _this.state.content // mutates state directly

        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showSidebar", function (e, id, props) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      if (_this.state.editingContent) {
        if (_this.state.editingContent.id === id) {
          return; // noop
        }

        if (props && props.prev && props.next && JSON.stringify(props.prev) !== JSON.stringify(props.next)) {
          return _this.setState({
            unsavedChanges: id
          });
        }
      }

      _this.setState({
        editingContent: _this.findContentById(id),
        editingPath: _this.findContentPathById(id),
        unsavedChanges: null
      });
    });
    var components = combineComponents(_props.components);
    _this.state = {
      editingPath: null,
      editingContent: null,
      content: Editor.setDefaultProps(_props.content && _props.content.length ? _props.content : [{
        id: (0, _generateUuid["default"])(),
        type: "Row",
        attrs: {
          disableDelete: true,
          allowChildren: true
        },
        content: []
      }], components),
      components: components,
      toolboxModalId: null,
      unsavedChanges: null
    };
    return _this;
  }

  (0, _createClass2["default"])(Editor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps.content) !== JSON.stringify(this.props.content)) {
        this.setState({
          content: Editor.setDefaultProps(this.props.content, this.state.components)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.keydownListener, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.keydownListener, false);
    }
  }, {
    key: "hasUnsavedChanges",
    value:
    /**
     * Used by parent before exporting json/html to make sure the last edited content block is fully saved
     * Returns boolean, but has side effect of triggering unsaved changes modal
     */
    function hasUnsavedChanges(cb) {
      var activeContentBlockId = this.state.editingContent && this.state.editingContent.id;

      if (activeContentBlockId) {
        this.setState({
          unsavedChanges: cb
        });
        return true; // Indicator to parent form to wait on exporting json / html
      }

      return false; // Indicator to parent form it's ok to export json / html
    }
  }, {
    key: "handleUnsavedChanges",
    value: function handleUnsavedChanges() {
      var contentIdOrCallback = this.state.unsavedChanges;

      if (contentIdOrCallback && typeof contentIdOrCallback !== "function") {
        this.showSidebar(null, contentIdOrCallback);
      } else if (contentIdOrCallback) {
        contentIdOrCallback(); // callback function from parent after we confirmed latest component changes were saved or discarded
      }
    }
  }, {
    key: "flattenDeep",
    value: function flattenDeep(content) {
      var _this2 = this;

      var flattened = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return (0, _values["default"])((0, _transform["default"])(content, function (memo, child) {
        if (child && child.id) {
          memo[child.id] = child;

          if (child.content && child.content.length) {
            memo = memo.concat(_this2.flattenDeep(child.content, memo));
          }
        }
      }, flattened));
    }
  }, {
    key: "recursiveDelete",
    value: function recursiveDelete(id, content) {
      var _this3 = this;

      content.forEach(function (child, idx) {
        if (child.id === id) {
          content.splice(idx, 1);
        } else if (child.content && child.content.length) {
          _this3.recursiveDelete(id, child.content);
        }
      });
    }
  }, {
    key: "findContentById",
    value: function findContentById(id) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.content;
      var allContent = this.flattenDeep(content);
      return (0, _find["default"])(allContent, {
        id: id
      });
    }
  }, {
    key: "generatePathObject",
    value: function generatePathObject(contents) {
      var _this4 = this;

      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (0, _reduce["default"])(contents, function (paths, content, index) {
        var component = (0, _find["default"])(_this4.state.components, {
          type: content.type
        });
        var rPath = [].concat((0, _toConsumableArray2["default"])(path), [{
          id: content.id,
          label: component && component.label ? component.label : content.type,
          type: content.type,
          index: index
        }]);
        paths[content.id] = rPath;

        if (content.content.length) {
          return _this4.generatePathObject(content.content, rPath, paths);
        }

        return paths;
      }, base);
    }
  }, {
    key: "findContentPathById",
    value: function findContentPathById(id) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.content;
      var paths = this.generatePathObject(content);
      return paths[id];
    }
  }, {
    key: "updateComponentAttrs",
    value: function updateComponentAttrs(id, attrs) {
      var _this5 = this;

      if (!id) {
        return;
      }

      var content = (0, _toConsumableArray2["default"])(this.state.content);
      var component = this.findContentById(id, content);

      if (!component) {
        return;
      }

      component.attrs = attrs;
      this.setState({
        editingContent: null,
        content: content
      }, function () {
        return _this5.handleUnsavedChanges();
      });
    }
  }, {
    key: "addChildToContent",
    value: function addChildToContent(id, type) {
      var content = (0, _toConsumableArray2["default"])(this.state.content);
      var components = this.state.components;

      if (id && type) {
        var parent = this.findContentById(id, content);

        if (!parent) {
          return;
        }

        var newComponent = (0, _find["default"])(components, {
          type: type
        });

        if (!newComponent) {
          return;
        }

        if (newComponent.generateContent && typeof newComponent.generateContent === "function") {
          parent.content = parent.content.concat(Editor.setDefaultProps(newComponent.generateContent({
            parent: parent
          }), this.state.components));
        } else {
          parent.content = parent.content.concat(Editor.setDefaultProps([{
            type: type,
            content: [],
            attrs: {},
            id: (0, _generateUuid["default"])()
          }], this.state.components));
        }
      }

      this.setState({
        editingContent: null,
        toolboxModalId: null,
        content: content
      });
    }
  }, {
    key: "getAttrsWithDefaults",
    value: function getAttrsWithDefaults(content) {
      var components = this.state.components;
      var component = (0, _find["default"])(components, {
        type: content.type
      });

      if (component && component.defaultAttrs) {
        return component.defaultAttrs(content.attrs);
      }

      return content.attrs;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          UPLOADCARE_API_KEY = _this$props.UPLOADCARE_API_KEY,
          placeholders = _this$props.placeholders,
          replacements = _this$props.replacements;
      var _this$state = this.state,
          toolboxModalId = _this$state.toolboxModalId,
          content = _this$state.content,
          editingContent = _this$state.editingContent,
          editingPath = _this$state.editingPath,
          components = _this$state.components;
      var formElement;
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: this.onDragEnd
      }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: editingContent ? _objectSpread({}, this.getAttrsWithDefaults(editingContent)) : {},
        onSubmit: function onSubmit(values) {
          return _this6.updateComponentAttrs(editingContent && editingContent.id, values);
        },
        render: function render(formProps) {
          var editingAttrs = editingContent && (Object.keys(editingContent.attrs) || []);
          var formValues = formProps && (Object.keys(formProps.values) || []);
          var internals = {
            isEditor: true,
            // an indicator to not show CSS related to editing content
            showSidebar: function showSidebar(e, id) {
              return _this6.showSidebar(e, id, {
                prev: editingContent && editingContent.attrs ? editingContent.attrs : {},
                next: formProps.values
              });
            },
            updateComponentAttrs: function updateComponentAttrs(id, attrs) {
              return _this6.updateComponentAttrs(id, attrs);
            },
            editingContentFormAttrs: formProps.values,
            editingContentId: editingContent && editingContent.id,
            addChildToContent: function addChildToContent(id) {
              if (_this6.hasUnsavedChanges(function () {
                _this6.setState({
                  editingContent: null,
                  unsavedChanges: null
                }, function () {
                  return _this6.openToolboxModal(id);
                });
              })) {
                return;
              }

              _this6.openToolboxModal(id);
            },
            components: components,
            deleteContent: function deleteContent(id) {
              return _this6.deleteContent(id);
            },
            placeholders: placeholders,
            replacements: replacements || {}
          };

          if (editingContent) {
            var _form = (0, _find["default"])(components, {
              type: editingContent.type
            }).Form;
            formElement = /*#__PURE__*/_react["default"].createElement(_form, {
              UPLOADCARE_API_KEY: UPLOADCARE_API_KEY,
              editingContentId: editingContent.id,
              placeholders: placeholders,
              replacements: replacements
            }, null);
          }

          return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
            className: (0, _classnames["default"])(classes.root, editingContent && classes.editingContent)
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.preview
          }, /*#__PURE__*/_react["default"].createElement(_RenderContent["default"], {
            content: content,
            internals: internals
          })), editingContent && formProps && JSON.stringify(editingAttrs) === JSON.stringify(formValues) ? /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.sidebar
          }, /*#__PURE__*/_react["default"].createElement(_SidebarForm["default"], {
            type: editingContent.type,
            cancelEdit: _this6.cancelEdit,
            breadcrumbs: editingPath,
            internals: internals,
            UPLOADCARE_API_KEY: UPLOADCARE_API_KEY
          }, formElement)) : null, /*#__PURE__*/_react["default"].createElement(_UnsavedChangesModal["default"], {
            id: toolboxModalId,
            discardChanges: _this6.cancelEdit,
            isOpen: _this6.state.unsavedChanges,
            type: editingContent && editingContent.type
          }), /*#__PURE__*/_react["default"].createElement(_ToolboxModal["default"], {
            id: toolboxModalId,
            components: components,
            onCancel: function onCancel() {
              return _this6.openToolboxModal(null);
            },
            onSelect: function onSelect(id, type) {
              return _this6.addChildToContent(id, type);
            },
            internals: internals
          }));
        }
      }));
    }
  }], [{
    key: "setDefaultProps",
    value: function setDefaultProps(content, components) {
      return content.map(function (child) {
        var component = (0, _find["default"])(components, {
          type: child.type
        });

        if (!(component.defaultAttrs && typeof component.defaultAttrs === "function")) {
          throw new Error("".concat(child.type, " must have Fn defaultAttrs({}) which returns default values for all form fields"));
        }

        return {
          id: child.id || (0, _generateUuid["default"])(),
          type: child.type,
          attrs: component.defaultAttrs(child.attrs || {}),
          content: child.content && child.content.length ? Editor.setDefaultProps(child.content, components) : Editor.setDefaultProps([], components)
        };
      });
    }
  }]);
  return Editor;
}(_react.Component);

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    root: {
      flex: "1",
      position: "relative",
      display: "flex",
      width: "100%",
      height: "100%",
      backgroundColor: "#fff"
    },
    editingContent: {
      "& $preview": (0, _defineProperty2["default"])({
        // paddingRight: "382px", // Scoots the preview over to ensure it doesn't render under the sidebar nav, not sure if I like this
        display: "none"
      }, theme.breakpoints(768), {
        display: "block"
      })
    },
    preview: {
      flex: "1",
      width: "100%",
      height: "auto",
      overflowX: "auto",
      overflowY: "auto",
      padding: "20px"
    },
    sidebar: (0, _defineProperty2["default"])({
      display: "flex",
      flexDirection: "column",
      flexShrink: "0",
      width: "100%",
      height: "100%",
      overflowX: "hidden",
      overflowY: "auto",
      background: theme.colors.gray050,
      padding: "8px",
      zIndex: _constants["default"].zIndex.sidebar,
      boxShadow: theme.globalBoxShadow
    }, theme.breakpoints(768), {
      width: "360px"
    })
  };
})(Editor); // Available to help with building components


exports["default"] = _default;
var Tools = {
  generateUUID: _generateUuid["default"],
  ToolboxItem: _ToolboxItem["default"],
  renderReact: renderReact,
  applyDefaults: _applyDefaults["default"],
  utilsExport: _export["default"],
  cloneContent: _cloneContent["default"],
  stringReplace: _stringReplace["default"]
};
exports.Tools = Tools;
var Components = {
  Row: _Row["default"],
  Script: _Script["default"],
  Button: _Button["default"],
  HorizontalRule: _HorizontalRule["default"],
  Image: _Image["default"],
  Text: _Text["default"],
  TwoCol: _TwoCol["default"],
  ThreeCol: _ThreeCol["default"],
  FourCol: _FourCol["default"],
  FiveCol: _FiveCol["default"],
  Email: {
    Row: _Row2["default"],
    HorizontalRule: _HorizontalRule2["default"],
    Image: _Image2["default"],
    Wrapper: _Wrapper["default"]
  }
};
exports.Components = Components;
var EmailComponents = combineComponents([_Row2["default"], _HorizontalRule2["default"], _Wrapper["default"], _Image2["default"], _Button2["default"]]);
exports.EmailComponents = EmailComponents;